import React from 'react'
import {useTenantT} from '../../../../../../i18n'

export interface Quiz {
  id: string
  title: string
  instructions: string
  duration?: number
  question_count?: number
  subject?: {name?: string}
  class?: {name?: string}
}
interface QuizStartProps {
  quiz: Quiz
  onStart: () => void
  isLoading?: boolean
}

const QuizStart: React.FC<QuizStartProps> = ({quiz, onStart, isLoading}) => {
  const t = useTenantT()
  return (
    <div className='card shadow-sm'>
      <div className='card-body p-5'>
        <div className='text-center mb-4'>
          <h1 className='display-4 fw-bold text-primary mb-3'>{quiz.title}</h1>
          {/* <p className='lead text-muted'>{quiz.description}</p> */}
        </div>

        <div className='row text-center mb-4'>
          <div className='col-md-6 col-lg-3 mb-3'>
            <div className='bg-light rounded p-3'>
              <i className='bi bi-list-ol fs-4 text-primary d-block mb-2'></i>
              <h5 className='mb-1'>Total Questions</h5>
              <p className='fs-2 fw-bolder text-dark mb-0'>{quiz.question_count}</p>
            </div>
          </div>
          <div className='col-md-6 col-lg-3 mb-3'>
            <div className='bg-light rounded p-3'>
              <i className='bi bi-clock fs-4 text-primary d-block mb-2'></i>
              <h5 className='mb-1'>Estimated Time</h5>
              <p className='fs-2 fw-bolder text-dark mb-0'>{quiz.duration} min</p>
            </div>
          </div>
          <div className='col-md-6 col-lg-3 mb-3'>
            <div className='bg-light rounded p-3'>
              <i className='bi bi-book fs-4 text-primary d-block mb-2'></i>
              <h5 className='mb-1'>{t('Subject')}</h5>
              <p className='fs-2 fw-bolder text-dark mb-0'>{quiz.subject?.name || 'N/A'}</p>
            </div>
          </div>
          <div className='col-md-6 col-lg-3 mb-3'>
            <div className='bg-light rounded p-3'>
              <i className='bi bi-people fs-4 text-primary d-block mb-2'></i>
              <h5 className='mb-1'>{t('Class')}</h5>
              <p className='fs-2 fw-bolder text-dark mb-0'>{quiz.class?.name || 'N/A'}</p>
            </div>
          </div>
        </div>

        <div className='alert alert-info' role='alert'>
          <i className='bi bi-info-circle me-2'></i>
          <strong>Instructions:</strong>{' '}
          <div dangerouslySetInnerHTML={{__html: quiz.instructions}} />
        </div>

        <div className='text-center mt-4'>
          <button
            className='btn btn-primary btn-lg px-5 py-3'
            onClick={onStart}
            data-kt-indicator={isLoading ? 'on' : 'off'}
            disabled={isLoading}
          >
            <i className='bi bi-play-fill me-2'></i>
            Start Quiz
            <span className='indicator-progress'>
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default QuizStart
